import Vue from 'vue'
import ChatBox from './packages/chatBox/index.js';

const components = [
  ChatBox
]

const install = function (Vue, opts = {}) {
  components.map(component => {
    Vue.component(component.name, component);
  })
}

/* 支持使用标签的方式引入 */
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
}

export default {
  install,
  ChatBox
}


// WEBPACK FOOTER //
// ./src/index.js